module.exports = __webpack_public_path__ + "img/nota-folio-farmacias-descuento.cecd5a21.png";